/**
 * List of email templates for the Gift Card feature.
 */
export const GiftCardEmailTemplates = {
  SendGiftCardsBatchSuccess: 87,
  SendGiftCardsBatchFailure: 88
} as const;
